import { render, staticRenderFns } from "./PhpManagerView.vue?vue&type=template&id=1fb13022&"
import script from "./PhpManagerView.vue?vue&type=script&lang=js&"
export * from "./PhpManagerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb13022')) {
      api.createRecord('1fb13022', component.options)
    } else {
      api.reload('1fb13022', component.options)
    }
    module.hot.accept("./PhpManagerView.vue?vue&type=template&id=1fb13022&", function () {
      api.rerender('1fb13022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/php/PhpManagerView.vue"
export default component.exports